import React from "react";
import { connect } from "react-redux";
import Flyout from "src/components/Flyout";
import Modal from "src/containers/Modal";
import { ApplicationStore } from "src/store";
import ElectricModal from "./ElectricModal";

export const Electric = ({ isAppOpen }: ReturnType<typeof mapStateToProps>) => {
    return (
        <div>
            <ElectricModal isAppOpen={isAppOpen} />
            <Modal />
            <Flyout />
        </div>
    );
};

function mapStateToProps({ onlineShopper }: ApplicationStore) {
    return {
        isAppOpen: onlineShopper.isAppOpen,
    };
}

export default connect(mapStateToProps)(Electric);
